import { DeepLink } from "./DeepLink";
import { DeeplinkParser, DeepLinkTypes } from "./types";

const unknowDeepLink = () => new DeepLink({ type: DeepLinkTypes.unknow });

const httpParser: DeeplinkParser = (url: URL, _: any) => {
    return new DeepLink({
        type: DeepLinkTypes.url,
        data: {
            url: url.toString()
        }
    })
}

const webActorParser: DeeplinkParser = (_: URL, params: any) => {
    if (params && params.url && params.url.indexOf('static.appercode.com/meetings') >= 0) {
        const webUrl = new URL(params.url);
        const id = webUrl.searchParams.get("id");

        if (id) {
            return new DeepLink({
                type: DeepLinkTypes.meeting,
                data: {
                    id: id
                }
            })
        }
    }

    return unknowDeepLink();
}

const htmlPageActorParser: DeeplinkParser = (_: URL, params: any) => {
    if (params?.schemaId) {
        return new DeepLink({
            type: DeepLinkTypes.htmlPage,
            data: {
                id: params.objectId ?? null
            }
        })
    }

    return unknowDeepLink();
}

const browserParser: DeeplinkParser = (url: URL, _: any) => {

    const href = url.href.replace('browser:?', '');

    return new DeepLink({
        type: DeepLinkTypes.url,
        data: {
            url: href
        }
    })
}

const eventParser: DeeplinkParser = (_: URL, params: any) => {
    return new DeepLink({
        type: DeepLinkTypes.event,
        data: {
            id: params.objectId ?? null,
        }
    });
}

const userProfileParser: DeeplinkParser = (url: URL, params: any) => {
    if (params.objectId) {
        return new DeepLink({
            type: DeepLinkTypes.userProfile,
            data: {
                id: params.objectId ?? null,
            }
        });
    }

    return unknowDeepLink();
}

const agendaParser: DeeplinkParser = (_: URL, params: any) => {
    if (params && params.schemaId && params.schemaId == process.env.VUE_APP_AGENDA_SCHEMA) {
        return new DeepLink({
            type: DeepLinkTypes.session,
            data: {
                id: params.objectId ?? null,
                schemaId: params.schemaId
            }
        })
    }

    return unknowDeepLink();
}

const generalCatalogParser: DeeplinkParser = (_: URL, params: any) => {
    if (params?.schemaId) {
        return new DeepLink({
            type: DeepLinkTypes.catalog,
            data: {
                id: params.objectId ?? null,
                schemaId: params.schemaId ?? null
            }
        })
    }

    return unknowDeepLink();
}

const actorParsers: Record<string, DeeplinkParser> = {
    'EventsPageActor': eventParser,
    'AgendaPageActor': agendaParser,
    'GeneralCatalogPageActor': generalCatalogParser,
    'WebBrowserActor': webActorParser,
    'HtmlPageActor': htmlPageActorParser,
    'ContactsPageActor': userProfileParser
}

const parsers: Record<string, DeeplinkParser> = {
    'http:': httpParser,
    'https:': httpParser,
    'browser:': browserParser
}

export {
    actorParsers,
    parsers,
    unknowDeepLink
}